import { useMemo } from "react";
import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function useCurrentUserGroups() {
  const [currentUser] = useQuery(queries.currentUser());
  const [groups] = useQuery(queries.currentUserGroups());

  const groupIds = useMemo(() => groups.map((g) => g.id), [groups]);

  return { currentUser, groups, groupIds };
}
